import Constants from '@usas/ui-web/utils/Constants';
import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getOmeMeetOrgUnitEntryInfoData from './GetOmeMeetOrgUnitEntryInfoData';

export const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  omeMeetOrgUnitEntryId: Constants.DEFAULT_ID
};

const OmeMeetOrgUnitEntryInfoData = {
  getOmeMeetOrgUnitEntryInfoData,
  INITIAL_STATE
};

export default OmeMeetOrgUnitEntryInfoData;